import { useBlockProps, InnerBlocks } from "@wordpress/block-editor";
import { getAllSpacingVars } from "../utils/spacingUtils";
import { getAllFlexboxVars } from "../utils/flexboxUtils";

export default function save({ attributes }) {
	const spacingVars = getAllSpacingVars(attributes);
	const flexboxVars = getAllFlexboxVars(attributes);

	// Combine all CSS vars
	const allVars = { ...spacingVars, ...flexboxVars };

	// Manually create style string for CSS custom properties
	const inlineStyle =
		Object.keys(allVars).length > 0
			? Object.entries(allVars)
					.map(([key, value]) => `${key}:${value}`)
					.join(";")
			: undefined;

	const { displayType = "block" } = attributes;

	const blockProps = useBlockProps.save();

	// Manually build the final className
	const finalClassName = [
		blockProps.className,
		displayType === "flex" ? "is-flex" : "",
	]
		.filter(Boolean)
		.join(" ");

	return (
		<div
			{...blockProps}
			className={finalClassName}
			{...(inlineStyle && { style: inlineStyle })}
		>
			<InnerBlocks.Content />
		</div>
	);
}
